import WarehousesService from '~/services/warehouses.service';
import { EXPENSES } from '~/lib/constants';
import { CreateWarehouseModel } from '~/models/warehouse';
import { CreateLeasedWarehouseModel } from '~/models/warehouse-leased';
import { uiActions } from '~/store/actions';
import { gameSelectors, warehouseSelectors } from '~/store/selectors';
import { inboxActions, loadingActions } from '~/store';
// ---- internal imports ------

import * as types from './actionTypes';
// ---- local imports ------

export function fetchAllWarehouses() {
	return async (dispatch) => {
		try {
			const result = await WarehousesService.fetchAllWarehouses();
			if (!result.isSuccess) {
				return;
			}

			const allWarehouses = result.data;
			const allWarehousesFormatted =
				allWarehouses.map((warehouse) => CreateWarehouseModel(warehouse));
			dispatch({ type: types.WAREHOUSE_FETCHED_ALL, allWarehouses: allWarehousesFormatted });
		} catch (error) {
			console.error(error);
		}
	};
}

export function fetchLeasedWarehouses() {
	return async (dispatch, getState) => {
		try {
			const gameUserId = gameSelectors.getGameId(getState());
 
			const result = await WarehousesService.fetchLeasedWarehouses(gameUserId);
			if (!result.isSuccess) {
				return;
			}

			const leasedWarehouses = result.data;
			const leasedWarehousesFormatted = leasedWarehouses.map((warehouse) => {
				const warehouseInfo = warehouseSelectors
					.getWarehouse(getState(), warehouse.warehouse_id);
				return CreateLeasedWarehouseModel(warehouse, warehouseInfo);
			});
			dispatch({
				type: types.WAREHOUSE_FETCHED_LEASED,
				leasedWarehouses: leasedWarehousesFormatted
			});
		} catch (error) {
			console.error(error);
		}
	};
}

export function unlease(leasedWarehouseId) {
	return async (dispatch, getState) => {
		try {
			const gameUserId = gameSelectors.getGameId(getState());

			dispatch(loadingActions.start(types.WAREHOUSE_UNLEASED));

			const result =  await WarehousesService
				.unleaseWarehouse(gameUserId, leasedWarehouseId);
			if (!result.isSuccess) {
				dispatch(loadingActions.endAfterNetworkFaliures());
				return false;
			}

			const leasedWarehouses = result.data;
			await dispatch(loadingActions.end(types.WAREHOUSE_UNLEASED));

			dispatch({ type: types.WAREHOUSE_UNLEASED });

			const leasedWarehousesFormatted = leasedWarehouses.map((warehouse) => {
				const warehouseInfo = warehouseSelectors
					.getWarehouse(getState(), warehouse.warehouse_id);
				return CreateLeasedWarehouseModel(warehouse, warehouseInfo);
			});
			dispatch({
				type: types.WAREHOUSE_FETCHED_LEASED,
				leasedWarehouses: leasedWarehousesFormatted
			});

			return true;
		} catch (error) {
			console.error(error);
		}
	};
}

export function lease(warehouseId) {
	return async (dispatch, getState) => {
		try {
			const gameUserId = gameSelectors.getGameId(getState());
			dispatch(loadingActions.start(types.WAREHOUSE_LEASED));
			const result = await WarehousesService
				.leaseWarehouse(gameUserId, warehouseId);

			if (!result.isSuccess) {
				dispatch(loadingActions.endAfterNetworkFaliures());
				return false;
			}

			const { leasedWarehouses, notifications } = result.data;

			await dispatch(loadingActions.end(types.WAREHOUSE_LEASED));
			const leasedWarehousesFormatted = leasedWarehouses.map((warehouse) => {
				const warehouseInfo = warehouseSelectors
					.getWarehouse(getState(), warehouse.warehouse_id);
				return CreateLeasedWarehouseModel(warehouse, warehouseInfo);
			});
			dispatch({
				type: types.WAREHOUSE_FETCHED_LEASED,
				leasedWarehouses: leasedWarehousesFormatted
			});
			notifications && dispatch(inboxActions.handleNewMessage(notifications));
			const shouldShowExpenseThisRound =
				!warehouseSelectors.hasWarehouseUnleasedThisTurn(getState());
			if (shouldShowExpenseThisRound) {
				const warehouse = warehouseSelectors.getWarehouse(getState(), warehouseId);
				dispatch({ type: types.WAREHOUSE_LEASED, warehouse });
				dispatch(uiActions.addNewExpenseToDisplay(EXPENSES.WAREHOUSE, warehouse.price));
			}

			return true;
		} catch (error) {
			console.error(error);
		}
	};
}
